import React, { useState } from "react";
import Navbar from "../component/Navbar";
import { Link } from "react-router-dom";
import Webimagefooter from "../component/Login/Webimagefooter";
import { useNavigate } from "react-router-dom";
import Activityindicator from "../Activityindicator";
import { url } from "../api/api";
import axios from "axios";

const Login = () => {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [isLoading, setisLoading] = useState(false);
  const [error, seterrorStatus] = useState("");
  const navigate = useNavigate();

  console.log(error);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setisLoading(true);

    const newData = {
      email: formData.email,
      password: formData.password,
      isAdmin: false,
    };
    await axios
      .post(`${url}/users/signin`, newData, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        // Process the successful response here

        setisLoading(false);
        localStorage.setItem("userdata", JSON.stringify(response.data));

        navigate("/dashboard");
      })
      .catch((error) => {
        // Handle error responses here
        if (error.response) {
          if (error.response.status === 401) {
            seterrorStatus("Invalid email or password");
            setisLoading(false);
          } else if (error.response.status === 422) {
            setisLoading(false);
            localStorage.setItem("useridkey", error.response.data.userid);

            navigate("/verifyemail");
          } else {
            seterrorStatus("Unknown error exist while submiting form");
            setisLoading(false);
          }
        } else {
          console.error("Error:", error.message);
          setisLoading(false);
        }
      });
  };

  return (
   <div className="w-full h-[1000px] bg-[radial-gradient(89.62%_213.03%_at_38.75%_80.3%,_#07031C_0%,_#241D4A_30.52%,_#07031C_64.32%)]">

      <Navbar />

      <div className=" w-full h-screen md:h-screen grid place-items-center z-50" >
        <div className=" md:border-[0.5px] border-opacity-30 text-white  border-[#D4F5F9] rounded-[15px] md:shadow-lg p-8 max-w-lg w-full md:mt-32 mt-[-0px;]">
          <div className="px-4 py-4 ">
            <h2 className="md:text-[32px] text-[25px] font-bold mb-6 text-center text-[#F2C493]  font-lato">
              Login to your Account
            </h2>
            <p className=" text-[16px] font-lato text-[#D4F5F9] font-normal mt-[-25px] text-center">
              Securely login to your Capital Nest’s account{" "}
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4 mt-[30px]">
           {error && (
  <div className="w-full bg-[#FF4C4C]/10 border border-[#FF4C4C] text-[#FF4C4C] px-4 py-3 rounded-md font-lato text-sm flex items-start gap-2">
    <svg className="w-5 h-5 mt-[2px]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M12 9v2m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    </svg>
    <span>{error}</span>
  </div>
)}

            <div>
              <label
                htmlFor="email"
                className="block text-[16px]  ml-2  font-lato font-normal mb-1 text-[#FFFFFF]"
              >
                Email Address
              </label>
              <input
                type="email"
                id="email"
                className="focus:bg-transparent focus:outline-none w-full  h-[50px] border-[0.5px] border-opacity-30 bg-transparent hover:bg-transparent border-[#D4F5F9]  rounded-[10px] "
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            <div>
              <label
                htmlFor="password"
                className="block   text-[16px]  font-lato font-normal ml-2  mb-1 text-[#FFFFFF]"
              >
                Password
              </label>
              <input
                type="password"
                id="password"
                className=" focus:bg-transparent focus:outline-none w-full  bg-transparent  h-[50px] border-[0.5px] border-opacity-30  border-[#D4F5F9] rounded-[10px]"
                name="password"
                value={formData.password}
                onChange={handleChange}
                required
              />
            </div>

          

            <p className=" text-[#D4F5F9] text-[16px] ml-2 font-lato font-normal mt-[-40px] ">
           By Creating an account, I agree to Capital Nest’s  terms and  condition
            </p>

            <br />

            <div className=" mt-[146px]">
              {isLoading ? (
                <Activityindicator />
              ) : (
                <button
                  type="submit"
                  className="  font-[istok] w-full py-4 px-4 bg-[#D4F5F9] rounded-md  focus:outline-none focus:ring-2 focus:ring-black text-black"
                >
                  Login
                </button>
              )}
            </div>

        <p className="text-[#F2C493] font-[istok]  mt-36 leading-4">
  Don’t have an account?{" "}
  <Link to="/signup" className="text-[#fff] font-[istok]">
    Sign Up Here
  </Link>
</p>
<p className="text-[#F2C493] font-[lato]  leading-tight">
  Forgot password?{" "}
  <Link to="/forgotpass" className="text-[#fff] font-[lato]">
    Click Here
  </Link>{" "}
  we can help
</p>

          </form>
        </div>
      </div>

      <Webimagefooter />
    </div>
  );
};

export default Login;
